<template>
  <div class="System">
    <h1>OEE </h1>
    <h2>排班 </h2>

    <table border="3" width="700px">  <!--border：表格边框，width：表格宽度-->
         <caption ></caption>  <!--标题标签，居中显示，仅有一个标题-->
         <tr>
         	<th>名称</th>
         	<th>开始时间</th>
         	<th>结束时间</th>
         </tr>
         <tr  v-for="item in items">
         	<td >
            <label> {{item.name}}</label>
          </td>  
          
         	<td><input id="meeting" type="date" v-model="item.start"/></td>
         	<td><input id="meeting" type="date" v-model="item.end"/></td>         	
         </tr>
     </table>

    <p>

    <button v-on:click="click()">更新</button>
  </p>
  </div>
</template>


<script>
export default {
  name:'about',
  data() {
    return {
      refreshTime: '',
      items: [
      {name: '星期一' ,start :'2022-12-13',end :'2022-12-13'},
      {name: '星期二' ,start :'2022-12-13',end :'2022-12-13'}
    ]
    }
  },
  mounted(){
   
    this.$data.refreshTime =this.$cookies.get('refreshTime')

    this.$http.get('http://127.0.0.1:5233/api/Polestar/System/Get')
              .then(function (response) {

                console.log(response.data);
                console.log(response.status);
                console.log(response.statusText);
                console.log(response.headers);
                console.log(response.config);

              })
              .catch(function (error) {
                console.log(error);
              });
  },
  methods:{
    click(){

      this.$cookies.set('refreshTime', this.$data.refreshTime )

    }
  }
}
</script>